import axios from 'axios';
import get from 'lodash/get';

// Libs
import { thunkHandler, thunkErrorHanlder } from '../../libs/utils';

// Constants
import { ONBOARDING } from '../../constants/endpoints';

export const NEW_ONBOARDING = 'NEW_ONBOARDING';
export const SHOW_TOPBAR    = 'SHOW_TOPBAR';

export function getOnBoarding() {
  return dispatch => axios.get(ONBOARDING)
    .then(res => thunkHandler(dispatch, get(res, 'data'), NEW_ONBOARDING, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getOnBoarding

export function onChangeShowTopBar(value) {
  return dispatch => Promise.resolve(dispatch({
    type: SHOW_TOPBAR,
    payload: value
  }))
  
} // END onChangeShowTopBar



// WEBPACK FOOTER //
// ./src/redux/actions/onBoardingActions.js